const optionWidthsData2 = [
  {
    Option: '4a',
    Sidewalk1: 19,
    CurbExtension1: 0,
    BikeLane: 10,
    SharedLane: 0,
    BusLane: 12,
    ParkingBay: 0,
    CurbExtension2: 0,
    Sidewalk2: 19,
    Total: 60,
    Note: 'One Way',
  },
  {
    Option: '4b',
    Sidewalk1: 19,
    CurbExtension1: 0,
    BikeLane: 10,
    SharedLane: 12,
    BusLane: 0,
    ParkingBay: 0,
    CurbExtension2: 0,
    Sidewalk2: 19,
    Total: 60,
    Note: 'One Way',
  },
  {
    Option: '4c',
    Sidewalk1: 19,
    CurbExtension1: 10,
    BikeLane: 0,
    SharedLane: 0,
    BusLane: 12,
    ParkingBay: 0,
    CurbExtension2: 0,
    Sidewalk2: 19,
    Total: 60,
    Note: 'One Way',
  },
  {
    Option: '4d',
    Sidewalk1: 19,
    CurbExtension1: 10,
    BikeLane: 0,
    SharedLane: 12,
    BusLane: 0,
    ParkingBay: 0,
    CurbExtension2: 0,
    Sidewalk2: 19,
    Total: 60,
    Note: 'One Way',
  },
];

export default optionWidthsData2;
